import React from 'react'
import { Grid, Typography } from '../../../mui/Core/index'
import { errorMessages } from '../../../../constants/error-message-constants'

export function TableauRegistrationError() {
  const gridContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    mt: 50,
    alignItems: 'center',
  }
  const errorMessageStyle = { mt: 3 }

  return (
    <Grid container sx={gridContainerStyle}>
      <Grid>
        <Typography variant='h3'>{errorMessages.message.TABLEAU_ERROR_MESSAGE_1}</Typography>
        <Typography variant='errorMessage' sx={errorMessageStyle}>
          {errorMessages.message.TABLEAU_ERROR_MESSAGE_2}
        </Typography>
      </Grid>
    </Grid>
  )
}
